import React from "react"
import SEO from "components/seo"
import { Slider } from "sections/Homepage/Slider"
// import AniLink from "gatsby-plugin-transition-link/AniLink"

import { usePagesContent } from "shared/Hooks/PagesContent"
const IndexPage = () => {
  const pages = usePagesContent()

  return (
    <>
      <SEO title="Oficjalna strona Fundacji Beksiński" description="Fundacja Beksiński promuje twórczość wielkiego polskiego malarza - Zdzisława Beksińskiego organizując różnego rodzaju eventy i wystawy." />
      <Slider />
    </>
  )
}

export default IndexPage
